import { AbstractControl, FormArray } from '@angular/forms';

export class CustomValidators {
  static optionsValidator(formArray: AbstractControl): { [key: string]: any } | null {
    if (!(formArray instanceof FormArray)) {
      return null;
    }

    if (formArray.length === 0) {
      return { noOptions: true };
    }

    const hasEmptyOption = formArray.controls.some((group: AbstractControl) => {
      return group.get('text')?.value?.trim() === '';
    });

    return hasEmptyOption ? { emptyOption: true } : null;
  }
}
